// extracted by mini-css-extract-plugin
export default {"cardImage":"Card_cardImage__L++lZ","cardText":"Card_cardText__Uw3Xx","cardTextFourLines":"Card_cardTextFourLines__rZyqI"};